export const _previousWhiteboard = state => state.whiteboard.previousWhiteboard
